import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "@pressmedia/vuwjbform";
import _contentKey from "./_contentKey";
import _onReady from "./_onReady";
import _onChangeState from "./_onChangeState";
import _fixBottom from "./_fixBottom";
const { app } = window;

vuwer.setProp({
	promise: Promise.resolve(),
	
	..._contentKey,
	..._onReady,
	..._onChangeState,
	..._fixBottom,
	
	/**
	 * 現在アクティブなセクションを取得
	 * @returns {instance of Vuw}
	 */
	getActiveSection() {
		return u_.isString(this.currentView) && this.get(`${this.currentView}Section`);
	},
	currentView: null,
	
	/**
	 * seach and set childSections
	 * @returns this
	 */
	readChildSections() {
		this.childSections = [];
		
		const literal = /Section$/;
		
		this.getChildren().forEach(vuw => {
			if( literal.test(vuw.name) && vuw instanceof Klass("VuwFade") ) {
				this.childSections.push( vuw.name.replace(literal, "") );
			}
		});
		
		return this;
	},
	
	/**
	 * on ready
	 */
	onReadyFirst() {
		// seach and set childSections
		this.readChildSections();
		
		// meta for robots
		if(	u_.isObject(app.config.page) ) {
			if( !u_.hasProperty(app.config.page, "noindex") ) {
				app.config.page.noindex = true;
			}
			
			if( !u_.hasProperty(app.config.page, "nofollow") ) {
				app.config.page.nofollow = true;
			}
		} else {
			app.config.page = {
				noindex: true,
				nofollow: true
			};
		}
	},
});

// export to window
Object.assign(window, {
	vuwer
});

export default vuwer;
